/**
 * Mise en page de la page publique d'une cagnotte (/c/<slug>) — UN SEUL
 * réglage (Karim 2026-10-13) : « immersif » est la version retenue. Les trois
 * autres sont GARDÉES, prêtes à resservir si on change d'avis :
 *  · « mosaique »  : titre au-dessus, mosaïque 1 grande + 4 petites photos ;
 *  · « banniere »  : titre seul, bannière à flèches dans la colonne de gauche ;
 *  · « ancien »    : la page d'avant 2026-10-13 (onglets, carte de don,
 *                    barre collante), dans `components/page-cagnotte/ancien/`.
 *
 * Pour changer : modifier `MODELE_PAGE_CAGNOTTE` ci-dessous. En
 * développement, `?modele=mosaique|banniere|ancien|immersif` permet de les
 * comparer sans rien modifier (jamais en ligne).
 */
import type { ModelePageCagnotte } from "~/components/page-cagnotte/types";

export type ModeleCagnotte = ModelePageCagnotte | "ancien";

export const MODELES_CAGNOTTE: readonly ModeleCagnotte[] = ["immersif", "mosaique", "banniere", "ancien"];

export const MODELE_PAGE_CAGNOTTE: ModeleCagnotte = "immersif";

/** Le modèle à afficher : le réglage, ou `?modele=` en développement. */
export function modeleCagnotteDemande(query: Record<string, unknown>): ModeleCagnotte {
  if (import.meta.dev) {
    const demande = String(query.modele ?? "");
    if ((MODELES_CAGNOTTE as readonly string[]).includes(demande)) return demande as ModeleCagnotte;
  }
  return MODELE_PAGE_CAGNOTTE;
}
